import axios from './axios';

export function updateEmailSubscriptions(subscriptions: any): Promise<any> {
  return axios.put('/email-subscriptions.json', { subs: subscriptions })
    .then(response => response.data);
}
